import { OccasionPageLayout } from '@/components/seo/OccasionPageLayout';
import { getOccasion } from '@/data/occasions';
export default function BirthdayForMom() {
  const o = getOccasion('birthday-for-mom')!;
  return <OccasionPageLayout occasion={o} />;
}
